// 错误
export const GOODSMANAGEMENT_FILE = 'GOODSMANAGEMENT_FILE';
// 更新
export const GOODSMANAGEMENT_UPDATE = 'GOODSMANAGEMENT_UPDATE';
